import type { Epic } from 'Flux/index.js'
import { projectSlice } from 'Flux/Slice/Project/ProjectSlice.js'
import { catchError, EMPTY, expand, filter, map, of, switchMap, takeUntil, timer } from 'rxjs'

const PAGE_DELAY_MS = 0

export const GetProjectSamplesEpic: Epic = (action$, state$, { [projectSlice.name]: project, ProjectRepository }) =>
  action$.pipe(
    filter(project.getProjectSamplesRequest.match),
    switchMap(({ payload: { projectId, pageSize = 50 } }) => {
      const page$ = (offset?: number) => ProjectRepository.getProjectSamplesPage(projectId, { limit: pageSize, offset })

      return page$(0).pipe(
        expand((page /*, idx */) =>
          page.nextOffset != null ? timer(PAGE_DELAY_MS).pipe(switchMap(() => page$(page.nextOffset!))) : EMPTY
        ),
        map((page, index) =>
          project.getProjectSamplesRequestComplete({
            items: page.items,
            nextOffset: page.nextOffset ?? null,
            append: index > 0,
            total: page.totalItems
          })
        ),
        // cancel if another request for samples starts (route change, new project, etc.)
        takeUntil(action$.pipe(filter(project.getProjectSamplesRequest.match))),
        catchError((error) => of(project.getProjectSamplesRequestFailure({ error })))
      )
    })
  )
